import { apiURL, responseFormat } from '@/service/base'
import { MembersClient } from '@circusmonkey/spock-protobuf/ts/frontend/member_grpc_web_pb.js'
import { MemberLoginReq } from '@circusmonkey/spock-protobuf/ts/account/account_pb.js'
import { LobbyGameListReq } from '@circusmonkey/spock-protobuf/ts/frontend/member_pb.js'
import Protobuf from '../../plugins/protobuf'

const client = new MembersClient(apiURL, null, null)

/**
 * 取遊戲清單
 * @param func
 * @returns {Promise<unknown>}
 */
async function getGameList(params = {}, func = null) {
	const req = new proto.base.Empty()

	const option = { 'grpc-session': localStorage.getItem('grpc-session') }
	const url = String(client.getLobbyGameList.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	return new Promise((resolve, reject) => {
		client.getLobbyGameList(req, option, (err, response) => {
			if (typeof func === 'function') resolve(func(err, response, track))
			else resolve(responseFormat(err, response, track, true, 'game list'))
		})
	}).then(resp => resp)
}

/**
 * 取訪客遊戲清單
 * @param func
 * @returns {Promise<unknown>}
 */
async function getGuestGameList(params = {}, func = null) {
	const req = new LobbyGameListReq()
	req.setIsDemo(Protobuf.boolean(true))
	console.log('取訪客遊戲清單')

	const option = { 'grpc-session': localStorage.getItem('grpc-session') }
	const url = String(client.getLobbyGameList.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	return new Promise((resolve, reject) => {
		client.getLobbyGameList(req, option, (err, response) => {
			if (typeof func === 'function') resolve(func(err, response, track))
			else resolve(responseFormat(err, response, track, true, 'game list'))
		})
	}).then(resp => resp)
}

/**
 * 開啟遊戲連結
 * @param func
 * @returns {Promise<unknown>}
 */
async function openGameURL(params = {}, lang, isDemo, func = null) {
	const req = new MemberLoginReq()
	req.setLang(Protobuf.string(lang))
	req.setGameId(Protobuf.string(params.gameId))
	req.setIsDemo(isDemo)
	req.setOper(Protobuf.string(localStorage.getItem('oper')))
	// req.setBackurl(Protobuf.string(window.location.href))
	if(params.backurl) req.setBackurl(Protobuf.string(params.backurl))

	req.setMusic(Protobuf.boolean(localStorage.getItem('isMusicOpen') !== null ? JSON.parse(localStorage.getItem('isMusicOpen')) : true))
	req.setSound(Protobuf.boolean(localStorage.getItem('isSoundOpen') !== null ? JSON.parse(localStorage.getItem('isSoundOpen')) : true))
	const local = location.hostname.split('.')
	local.shift()
	const option = { 'grpc-session': localStorage.getItem('grpc-session') ,  'x-custom-game-host': `https://gs.${local.join('.')}` }
	const url = String(client.getGameUrl.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	return new Promise((resolve, reject) => {
		client.getGameUrl(req, option, (err, response) => {
			if (typeof func === 'function') resolve(func(err, response, track))
			else resolve(responseFormat(err, response, track, true, 'game url'))
		})
	}).then(resp => resp)
}

export {
	getGameList,
	getGuestGameList,
	openGameURL
}
